@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.body {
  @include card-shadow;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 10px;
  padding: 10px 12px;
  background: var(--light-80);
}

.postDetail {
  display: flex;
  align-items: center;
  gap: 5px;

  .avatar {
    width: 20px;
    height: 20px;
  }
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
